﻿import {
  faCheck,
  faInfoCircle,
  faTimes,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import NumberFormat from "react-number-format";
import { formatExpenseDate } from "../../helpers/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import { useParams, useHistory } from "react-router";
import { Toast } from "../UI/toast/Toast";
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import {
  changeStatusPayment,
  fetchOneAliquotByProperty,
  fetchOneBillToPay,
} from "../../helpers/api/finance";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import VoidPaymentModal from "./VoidPaymentModal";
import { rateRuleSummary } from "./RateRuleNotice";
import withRedirect from "../../helpers/hoc/withRedirect";
import ButtonIcon from "../common/ButtonIcon";
import PageHeader from "../common/PageHeader";
import Logo from "../navbar/Logo";
import SupportLink from "../root/support/components/SupportLink";
import { useReactToPrint } from "react-to-print";
import { CurrencyContext } from "../../context/Context";
import { findOneConfig } from "../../helpers/api/condominium";
import useSWRFetch from "../../helpers/hooks/useSWRFetch";
import useExchangeRateOnDate from "../../helpers/hooks/useExchangeRateOnDate";
import ItemImageTitleSubProperty from "../common/ItemImageTitleSubProperty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { formatAmountForBackend } from "../../helpers/currencyConversion";
import useModuleBase from "../../helpers/hooks/useModuleBase";

const PropertyPaymentDetail = ({ setRedirect, setRedirectUrl }) => {
  const moduleBase = useModuleBase();

  const { propertyPayment, id } = useParams();
  const history = useHistory();
  const reportRef = useRef();
  const { role } = useSelector((state) => state.auth.user);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { condominium, address, phone } = useSelector(
    (state) => state.condominium
  );
  const [aliquots, setAliquots] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const { data: dataConfig, isLoading: loadingConfig } = useSWRFetch(
    selectedCondominium,
    findOneConfig
  );

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const [datas, setDatas] = useState(null);
  const [isVoidOpen, setIsVoidOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const { data } = await fetchOneBillToPay(propertyPayment);
        isMounted && setDatas(data);
      } catch (error) {
        handleErrorMessage(error);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [reloadKey]);

  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const paymentDate = datas?.payment_date || datas?.created_at;
  const rateCurrency = datas?.exchange_rate?.currency || curr?.currency;
  const {
    rateValue: historicalRate,
    rateDateKey: historicalRateDate,
  } = useExchangeRateOnDate({
    currencyId: rateCurrency?.id,
    date: paymentDate,
    condominiumId: selectedCondominium,
    fallbackRate: 0,
  });
  const paymentRateValue = Number(datas?.exchange_rate?.value || 0);
  const resolvedRateValue =
    paymentRateValue > 0 ? paymentRateValue : historicalRate;
  const activeRate = {
    ...(datas?.exchange_rate || curr || {}),
    value: resolvedRateValue,
    currency:
      resolvedRateValue > 0
        ? datas?.exchange_rate?.currency || curr?.currency
        : undefined,
    date:
      datas?.exchange_rate?.date ||
      historicalRateDate ||
      paymentDate,
  };
  const hasActiveRate =
    Boolean(activeRate?.currency?.iso) && Number(activeRate?.value || 0) > 0;

  const formatDateSafe = (date) => {
    if (!date) return "";

    // Evita desfase por zona horaria cuando la API env├¡a solo YYYY-MM-DD.
    const raw = String(date).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const [year, month, day] = raw.split("-");
      return `${Number(day)}/${Number(month)}/${year}`;
    }

    const parsed = moment(raw);
    return parsed.isValid() ? parsed.format("D/M/YYYY") : "";
  };

  const cancel = async () => {
    try {
      // eslint-disable-next-line no-undef
      for (let index = 0; index < reference.length; index++) {
        const { code } = await changeStatusPayment(
          // eslint-disable-next-line no-undef
          reference[index].property_payment_id,
          { status: "canceled" }
        );
        if (code === SUCCESS_RESPONSE.SUCCESFUL) {
          setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments/properties`);
          setRedirect(true);
          Toast.fire({
            type: "success",
            title: `Pago cancelado exitosamente.`,
          });
        }
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const refuse = async () => {
    try {
      const { code } = await changeStatusPayment(propertyPayment, {
        status: "refused",
      });
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments/properties`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago cancelado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const propertyData = datas?.billPropertyPayment;

  const [report, setReport] = useState([]);
  const [reportE, setReportE] = useState([]);
  const [reportI, setReportI] = useState([]);
  const [funds, setFunds] = useState([]);
  const [reportIncomes, setReportIncomes] = useState([]);

  const fetchApireports = useCallback(async () => {
    if (!propertyData) return;
    try {
      // type.id 5 = "Deuda Inicial" (saldo inicial importado): se muestra junto
      // a los gastos ordinarios, no como extraordinario (ver TypeFinancesSeeder).
      const financeType1Reports = propertyData?.filter(
        (report) =>
          report?.property?.finance !== null &&
          (report?.property?.finance?.type?.id === 1 ||
            report?.property?.finance?.type?.id === 5)
      );
      const financeType2Reports = propertyData?.filter(
        (report) =>
          (report?.property?.finance !== null &&
            report?.property?.finance?.type?.id === 2) ||
          (!report?.property?.income_id &&
            !report?.property?.reserve_fund &&
            !report?.property?.reserve_fund_payment_id &&
            Number(report?.property?.amount) > 0 &&
            report?.property?.finance?.type?.id !== 1 &&
            report?.property?.finance?.type?.id !== 3 &&
            report?.property?.finance?.type?.id !== 5)
      );

      const financeType3Reports = propertyData?.filter(
        (report) =>
          report?.finance !== null && report?.property?.finance?.type?.id === 3
      );
      const reserveReports = propertyData?.filter(
        (report) => report?.property?.reserve_fund !== null
      );
      const incomeReports = propertyData?.filter(
        (report) =>
          Boolean(report?.property?.income_id) ||
          Boolean(report?.property?.income) ||
          Number(report?.property?.amount) < 0
      );

      setReport(financeType1Reports ?? []);
      setReportE(financeType2Reports ?? []);
      setReportI(financeType3Reports ?? []);
      setFunds(reserveReports ?? []);
      setReportIncomes(incomeReports ?? []);
    } catch (error) {
      setReport([]);
    }
  }, [propertyData]);

  useEffect(() => {
    fetchApireports();
  }, [fetchApireports, propertyData]);

  // HO-TASK-247: la suma conserva todos sus decimales. Redondear cada subtotal
  // a 2 y después sumarlos hacía que el total no coincidiera con la suma real
  // de las filas; los 2 decimales son solo para mostrar (NumberFormat).
  const categoryAmounts = React.useMemo(() => {
    const sumAmounts = (items, absolute = false) =>
      items.reduce(
        (sum, item) =>
          sum + (absolute
            ? Math.abs(Number(item?.property?.amount || 0))
            : Number(item?.property?.amount || 0)),
        0
      );

    return {
      amount: sumAmounts(report),
      amountE: sumAmounts(reportE),
      amountI: sumAmounts(reportI),
      amountF: sumAmounts(funds),
      amountIncomes: sumAmounts(reportIncomes, true),
    };
  }, [report, reportE, reportI, funds, reportIncomes]);

  const { amount, amountE, amountI, amountF, amountIncomes } = categoryAmounts;

  useEffect(() => {
    let isMounted = true;
    if (propertyData && datas?.billPropertyPayment[0]?.property?.property?.id) {
      (async () => {
        try {
          const { data } = await fetchOneAliquotByProperty(
            datas.billPropertyPayment[0].property.property.id
          );
          if (isMounted) setAliquots(data);
        } catch (error) {
          if (isMounted) handleErrorMessage(error);
        }
      })();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [propertyData]);

  useEffect(() => {
    datas?.billPropertyPayment?.reduce(
      (sum, pay) => sum + (pay?.property?.amount || 0),
      0
    );
  }, [datas?.billPropertyPayment]);

  const approve = async (data) => {
    try {
      const amountConverted = Number(datas?.amount) * Number(activeRate?.value || 0);
      const { code } = await changeStatusPayment(data, {
        status: "approved",
        amount_converted: Number.isFinite(amountConverted)
          ? formatAmountForBackend(amountConverted)
          : null,
      });
      if (code === SUCCESS_RESPONSE.SUCCESFUL) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/payments/properties`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago aprobado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const fechaFormateada = formatDateSafe(
    datas?.billPropertyPayment[0]?.property?.period?.end_at
  );

  const fechaFormateadaE = formatDateSafe(datas?.created_at);

  const totalAmount = Number(datas?.total_amount || 0);
  const reportedAmount = Number(datas?.amount || 0);
  const paidAmount = Number(datas?.paid_amount || 0);
  const paidAmountConverted = Number(datas?.paid_amount_converted || 0);
  const pendingAmount = Number(datas?.pending_amount || 0);
  const isFullyPaid = Boolean(datas?.is_fully_paid);
  // Porción del crédito por ingreso que le tocó a esta planilla, prorrateada
  // por el backend. null cuando no hay período o no hay crédito.
  const incomeCreditShare =
    datas?.income_credit_share === null || datas?.income_credit_share === undefined
      ? null
      : Number(datas.income_credit_share);

  // Qué categorías cubre esta planilla. Con el cobro por categoría una planilla
  // puede ser solo una parte del período, y sin decirlo se lee como si fuera la
  // deuda entera: "Saldo pendiente $0" parece que ya no se debe nada del mes.
  // Se toma del campo `category` que resuelve el backend, no de finance.type.
  const coveredCategories = React.useMemo(() => {
    const labels = {
      ordinary: "Comunes",
      particular: "Gastos Particulares",
      reserve_fund: "Fondos de Reserva",
      initial_debt: "Deuda Inicial",
    };

    const found = new Set();
    (datas?.billPropertyPayment || []).forEach((row) => {
      const debt = row?.property;
      // Las filas de crédito (ingreso a planilla, pronto pago) no son una
      // categoría cobrada: acompañan a la planilla como descuento.
      if (!debt || debt.category === "credit" || Number(debt.amount) <= 0) {
        return;
      }
      found.add(labels[debt.category] || labels.ordinary);
    });

    return [...found];
  }, [datas]);

  // Periodo al que pertenece esta planilla. Un pago de varios periodos se parte
  // en una planilla por periodo, asi que decir cual es evita leer el documento
  // como si fuera el pago completo.
  const coveredPeriodName = React.useMemo(() => {
    const rows = datas?.billPropertyPayment || [];

    for (const row of rows) {
      const name = row?.property?.period?.name;
      if (name) return name;
    }

    return null;
  }, [datas]);


  // Badge junto a "Monto abonado": si ESTE pago todav├¡a no est├í aprobado, su
  // monto no est├í incluido arriba ÔÇö se indica aparte con su propio valor.
  const depositBadge =
    datas?.status === "pending"
      ? {
          label: (
            <>
              +{" "}
              <NumberFormat
                displayType="text"
                prefix={`${baseCurrency.symbol} `}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator={true}
                value={reportedAmount}
              />{" "}
              por aprobar
            </>
          ),
          className: "badge-soft-warning",
        }
      : datas?.status === "refused"
        ? { label: "Rechazado", className: "badge-soft-danger" }
        : datas?.status === "canceled"
          ? { label: "Cancelado", className: "badge-soft-secondary" }
          : datas?.status === "voided"
            ? { label: "Anulado", className: "badge-soft-danger" }
            : null;

  const balanceBadge = isFullyPaid
    ? { label: "Pagado", className: "badge-soft-success" }
    : { label: "Pendiente", className: "badge-soft-warning" };

  const lineRateOf = (line) => Number(line?.exchange_rate?.value || 0);
  const lineIsoOf = (line) =>
    line?.exchange_rate?.currency?.iso || activeRate?.currency?.iso;

  const lineDateAndRateCells = (line) => (
    <>
      <td className="align-middle text-nowrap">
        {formatExpenseDate(line?.expense_date)}
      </td>
      <td className="align-middle text-nowrap">
        {lineRateOf(line) > 0 && lineIsoOf(line) && (
          <NumberFormat
            displayType="text"
            prefix={`${lineIsoOf(line)} `}
            allowedDecimalSeparators={true}
            decimalScale={2}
            fixedDecimalScale
            thousandSeparator={true}
            value={lineRateOf(line)}
          />
        )}
      </td>
    </>
  );

  const lineTotalCell = (line) => {
    const total = line?.concept_amount ?? line?.finance?.value;
    const totalBs =
      line?.concept_amount_converted ??
      (total !== null && total !== undefined && lineRateOf(line) > 0
        ? total * lineRateOf(line)
        : null);

    return (
      <td className="align-middle text-right">
        {total === null || total === undefined ? (
          "-"
        ) : (
          <>
            <span className="d-block font-weight-semi-bold">
              <NumberFormat
                className="text-nowrap"
                displayType="text"
                prefix={`${baseCurrency.symbol} `}
                allowedDecimalSeparators={true}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator={true}
                value={total}
              />
            </span>
            {totalBs !== null && lineIsoOf(line) && (
              <span className="d-block text-700 fs--2 text-nowrap">
                <NumberFormat
                  className="text-right text-nowrap"
                  displayType="text"
                  prefix={`${lineIsoOf(line)} `}
                  allowedDecimalSeparators={true}
                  decimalScale={2}
                  fixedDecimalScale
                  thousandSeparator={true}
                  value={totalBs}
                />
              </span>
            )}
          </>
        )}
      </td>
    );
  };

  return (
    <Fragment>
      <VoidPaymentModal
        isOpen={isVoidOpen}
        toggle={() => setIsVoidOpen(false)}
        kind="bill"
        paymentId={datas?.id}
        onVoided={() => setReloadKey((key) => key + 1)}
      />
      <PageHeader
        title="Detalle de pago"
        titleTag="h2"
        description={
          role === "property"
            ? "Visualiza tu pago realizado."
            : "Visualiza el pago del propietario"
        }
        className="mb-3"
        col={{ lg: 9 }}
      >
        {role === "manager" && <SupportLink />}
      </PageHeader>
      <Card className="mb-3">
        <CardBody>
          <Row className="justify-content-end align-items-center d-flex">
            <Col
              xs="auto"
              lg={"auto"}
              md={12}
              className="justify-self-end d-flex justify-content-end align-items-center"
            >
              <ButtonIcon
                onClick={() => history.goBack()}
                color="falcon-default"
                size="sm"
                icon="chevron-left"
                className="mr-2 mb-2 mb-sm-0"
              >
                Volver
              </ButtonIcon>
              <ButtonIcon
                color="falcon-default"
                size="sm"
                icon="arrow-down"
                disabled
                className="mr-2 mb-2 mb-sm-0"
              >
                Descargar (.pdf)
              </ButtonIcon>
              <ButtonIcon
                onClick={handlePrint}
                color="falcon-default"
                size="sm"
                icon="print"
                disabled={!datas}
                className="mr-2 mb-2 mb-sm-0"
              >
                Imprimir
              </ButtonIcon>
              {role === "property" && datas?.status === "pending" && (
                <ButtonIcon
                  color="falcon-danger"
                  size="sm"
                  icon={faTimes}
                  className="mb-2 mb-sm-0"
                  onClick={() => collapseOneOpen(!collapseOne)}
                >
                  Cancelar pago
                </ButtonIcon>
              )}
              {role === "manager" ? (
                datas?.status === "pending" ? (
                  <>
                    <ButtonIcon
                      color="falcon-success"
                      size="sm"
                      icon={faCheck}
                      className="mb-2 mr-2  mb-sm-0"
                      onClick={() => approve(datas?.id)}
                    >
                      Aprobar pago
                    </ButtonIcon>
                    <ButtonIcon
                      color="falcon-danger"
                      size="sm"
                      icon={faTimes}
                      className="mb-2 mb-sm-0"
                      onClick={() => refuse(datas?.data?.property_payment_id)}
                    >
                      Rechazar pago
                    </ButtonIcon>
                  </>
                ) : datas?.status === "approved" ? (
                  <ButtonIcon
                    color="falcon-danger"
                    size="sm"
                    icon={faBan}
                    className="mb-2 mb-sm-0"
                    onClick={() => setIsVoidOpen(true)}
                  >
                    Anular pago
                  </ButtonIcon>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </CardBody>
      </Card>

      {datas?.status === "voided" && (
        <Alert color="danger" className="shadow-sm fs--1">
          <strong className="d-block">Pago anulado</strong>
          {datas?.void_reason && (
            <span className="d-block">Motivo: {datas.void_reason}</span>
          )}
          <span className="d-block fs--2">
            {`Anulado el ${formatDateSafe(datas?.voided_at)}${datas?.voided_by_name ? ` por ${datas.voided_by_name}` : ""}`}
          </span>
        </Alert>
      )}

      <Fragment>
        <Card
          innerRef={(e) => {
            reportRef.current = e;
          }}
        >
          <CardBody>
            <ItemImageTitleSubProperty
              image={dataConfig?.data?.logo}
              title1={"Planilla de liquidación de gastos"}
              titleCondominium={`Condominio: ${condominium}`}
              titleProperty={"Datos del inmueble"}
              titleInvoice={"Datos adicionales"}
              condominium={[
                {
                  label: "Documento de identificación",
                  value: phone || "No disponible",
                },
                /*     {
                        label: "Teléfono",
                        value: userData.phone || "No disponible",
                      }, */
                { label: "Dirección", value: address },
              ]}
              property={[
                {
                  label: "Propietario",
                  value: `${datas?.billPropertyPayment[0].property.property?.user?.data?.firstname} ${datas?.billPropertyPayment[0].property.property?.user?.data?.lastname}`,
                },
                {
                  label: "Teléfono",
                  value: datas?.billPropertyPayment[0].property.property?.user
                    ?.data?.phone
                    ? datas?.billPropertyPayment[0].property.property?.user
                      ?.data?.phone
                    : "No disponible",
                },
                {
                  label: "Inmueble",
                  value: `${datas?.billPropertyPayment[0]?.property?.property
                    ?.property || "No disponible"
                    }`,
                },
                {
                  label: "Alícuota",
                  value: ((aliquots?.value || 0) / 100).toFixed(4),
                },
              ]}
              invoice={[
                ...(datas?.control_number
                  ? [{ label: "N° de control", value: datas.control_number }]
                  : []),
                {
                  label: "Fecha de emisión",
                  value: datas ? fechaFormateadaE : "No disponible",
                },
                {
                  label: "Fecha de vencimiento",
                  value: datas?.billPropertyPayment[0]?.property?.period?.end_at
                    ? fechaFormateada
                    : "No disponible",
                },
                {
                  label: "Estatus",
                  value:
                    datas?.status === "pending"
                      ? "Pendiente"
                      : datas?.status === "refused"
                        ? "Pago rechazado"
                        : datas?.status === "canceled"
                          ? "Cancelado"
                          : datas?.status === "voided"
                            ? "Anulado"
                            : "Aprobado",
                },
                {
                  label: "Período",
                  value: datas?.billPropertyPayment[0]?.property?.period?.name
                    ? datas?.billPropertyPayment[0]?.property?.period?.name
                    : "No disponible",
                },
                {
                  label: "Fecha de pago",
                  value: datas?.payment_date
                    ? formatDateSafe(datas?.payment_date)
                    : datas?.created_at
                      ? formatDateSafe(datas?.created_at)
                      : "",
                },
                {
                  label: "Tasa de cambio",
                  value:
                    activeRate?.currency?.iso && Number(activeRate?.value || 0) > 0 ? (
                      <>
                        <NumberFormat
                          displayType="text"
                          prefix={`${baseCurrency.symbol} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={1}
                        />
                        <NumberFormat
                          displayType="text"
                          prefix={` | ${activeRate.currency.iso} `}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={Number(activeRate.value)}
                        />
                        {(activeRate?.date || paymentDate) &&
                          ` (${formatDateSafe(activeRate?.date || paymentDate)})`}
                      </>
                    ) : (
                      "No disponible"
                    ),
                },
                // Con qué tasa se reportó y por qué. Los pagos anteriores a
                // la tasa congelada no la tienen.
                ...(rateRuleSummary(datas?.rate_rule)
                  ? [{ label: "Tasa aplicada", value: rateRuleSummary(datas.rate_rule) }]
                  : []),
              ]}
              loading={loadingConfig}
            />

            {datas && (
              // mb-3 como el resto de los bloques (HO-TASK-247): con
              // mt-1 mb-2 quedaba pegado a las tarjetas de datos.
              <div className="border border-200 rounded mb-3">
                <Row className="g-0 text-center text-sm-left">
                  <Col xs={12} sm={3} className="pl-4 pr-3 py-1">
                    <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                      Monto total
                    </div>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={totalAmount}
                      />
                    </div>
                    {hasActiveRate && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={totalAmount * (activeRate?.value || 0)}
                        />
                      </div>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    className="pl-3 pr-4 py-1 border-left border-200"
                  >
                    {/* flex-wrap: el badge del monto por aprobar es largo y la
                        columna angosta, asi que sin esto se desbordaba encima
                        de los tiles vecinos. Ahora baja a la linea de abajo. */}
                    <div
                      className="d-flex justify-content-between align-items-center flex-wrap mb-0"
                      style={{ gap: "0.25rem" }}
                    >
                      <span className="fs--1 text-600 font-weight-semi-bold">
                        Monto acumulado
                      </span>
                      {depositBadge && (
                        <Badge
                          className={classNames("rounded-capsule fs--2", depositBadge.className)}
                          style={{ whiteSpace: "normal" }}
                        >
                          {depositBadge.label}
                        </Badge>
                      )}
                    </div>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={paidAmount}
                      />
                    </div>
                    {hasActiveRate && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={paidAmountConverted}
                        />
                      </div>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    className="pl-3 pr-4 py-1 border-left border-200"
                  >
                    <div className="fs--1 text-600 font-weight-semi-bold mb-0">
                      Monto abonado
                    </div>
                    <div className="fs-0 font-weight-bold text-900">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={reportedAmount}
                      />
                    </div>
                    {hasActiveRate && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={reportedAmount * (activeRate?.value || 0)}
                        />
                      </div>
                    )}
                  </Col>
                  <Col
                    xs={12}
                    sm={3}
                    className="pl-3 pr-4 py-1 border-left border-200"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-0">
                      <span className="fs--1 text-600 font-weight-semi-bold">
                        Saldo pendiente
                      </span>
                      <Badge className={classNames("rounded-capsule", balanceBadge.className)}>
                        {balanceBadge.label}
                      </Badge>
                    </div>
                    <div
                      className={classNames(
                        "fs-0 font-weight-bold",
                        isFullyPaid ? "text-900" : "text-warning"
                      )}
                    >
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        allowedDecimalSeparators={true}
                        decimalScale={2}
                        fixedDecimalScale
                        thousandSeparator={true}
                        value={pendingAmount}
                      />
                    </div>
                    {activeRate?.currency?.iso && (
                      <div className="fs--1 text-600">
                        <NumberFormat
                          displayType="text"
                          prefix={activeRate.currency.iso + " "}
                          allowedDecimalSeparators={true}
                          decimalScale={2}
                          fixedDecimalScale
                          thousandSeparator={true}
                          value={pendingAmount * (activeRate?.value || 0)}
                        />
                      </div>
                    )}
                  </Col>
                </Row>

                {coveredCategories.length > 0 && (
                  <div className="px-3 pb-2 pt-1">
                    <span className="fs--1 text-600">
                      Esta planilla cubre:{" "}
                      <span className="font-weight-semi-bold text-800">
                        {coveredCategories.join(" + ")}
                      </span>
                      {coveredPeriodName && (
                        <>
                          {" "}
                          del período{" "}
                          <span className="font-weight-semi-bold text-800">
                            {coveredPeriodName}
                          </span>
                        </>
                      )}
                      <span className="text-muted">
                        {" "}
                        — un pago puede repartirse en varias planillas, una por
                        período.
                      </span>
                    </span>
                  </div>
                )}
              </div>
            )}

            {datas?.note != null && (
              <Row className="justify-content-between align-items-center fs--1 ">
                <Col>
                  <div className="text-start text-muted mt-3 pt-1 mb-0">
                    <div className="mb-0 d-flex align-items-center">
                      {" "}
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="me-2 mr-2"
                        size="sm"
                      />
                      <span className="text-start text-muted mr-2">Nota: </span>
                      <pre
                        style={{
                          fontFamily: "Open Sans",
                          fontSize: ".83333rem",
                          color: "#5e6e82",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                          margin: 0,
                        }}
                      >
                        {datas?.note}
                      </pre>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
            {datas?.bank != null && (
              <Row className="justify-content-between align-items-center fs--1 mt-4">
                <Col>
                  <div className="table-responsive">
                    <Table striped size="sm" borderless className="fs--1">
                      <tbody>
                        <>
                          <tr>
                            <td className="align-middle">Referencia</td>
                            <td className="align-middle">
                              {" "}
                              {datas != null ? datas.reference : ""}
                            </td>
                          </tr>
                          <tr>
                            <td className="align-middle">Banco destino</td>
                            <td className="align-middle">
                              {datas.bank != null ? datas.bank.name : ""}
                            </td>
                          </tr>
                          <tr>
                            <td className="align-middle">Titular</td>
                            <td className="align-middle">
                              {datas.bank != null ? datas.bank.owner_name : ""}
                            </td>
                          </tr>
                          <tr>
                            <td className="align-middle">DNI</td>
                            <td className="align-middle">
                              {datas.bank != null ? datas.bank.owner_dni : ""}
                            </td>
                          </tr>
                        </>
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            )}

            {report && report?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "22%" }}>Gastos ordinarios</th>
                      <th className="border-0" style={{ width: "14%" }}>Proveedor</th>
                      <th className="border-0" style={{ width: "16%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {report &&
                      report.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.name
                                ? pay?.property?.name
                                : pay?.property?.finance?.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance?.provider_name != null
                                ? pay?.property?.finance?.provider_name
                                : pay?.property?.finance?.provider?.name}
                            </p>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.description
                                ? pay?.property?.description
                                : pay?.property?.finance?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            {activeRate?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  prefix={activeRate.currency.iso + " "}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={
                                    pay?.property?.amount * (activeRate?.value || 0)
                                  }
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={6}>
                        Total de gastos ordinarios
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amount}
                          />
                        </span>
                        {activeRate?.currency?.iso && (
                          <span className="d-block text-700 fs--2 text-nowrap">
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              prefix={activeRate.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={amount * (activeRate?.value || 0)}
                            />
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {reportE && reportE?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "22%" }}>Gastos extraordinarios</th>
                      <th className="border-0" style={{ width: "14%" }}>Proveedor</th>
                      <th className="border-0" style={{ width: "16%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "10%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportE &&
                      reportE.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.name
                                : pay?.property?.reserve_fund.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance?.provider_name != null
                                ? pay?.property?.finance?.provider_name
                                : pay?.property?.finance?.provider?.name}
                            </p>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.description
                                : pay?.property?.reserve_fund?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            {activeRate?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  prefix={activeRate.currency.iso + " "}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={
                                    pay?.property?.amount * (activeRate?.value || 0)
                                  }
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={6}>
                        Total de gastos extraordinarios
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amountE}
                          />
                        </span>
                        {activeRate?.currency?.iso && (
                          <span className="d-block text-700 fs--2 text-nowrap">
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              prefix={activeRate.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={amountE * (activeRate?.value || 0)}
                            />
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}
            {reportI && reportI?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "26%" }}>Gastos particulares</th>
                      <th className="border-0" style={{ width: "22%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportI &&
                      reportI.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.name
                                : pay?.property?.reserve_fund.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.description
                                : pay?.property?.reserve_fund?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            {activeRate?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  prefix={activeRate.currency.iso + " "}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={
                                    pay?.property?.amount * (activeRate?.value || 0)
                                  }
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={5}>
                        Total de gastos particulares
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amountI}
                          />
                        </span>
                        {activeRate?.currency?.iso && (
                          <span className="d-block text-700 fs--2 text-nowrap">
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              prefix={activeRate.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={amountI * (activeRate?.value || 0)}
                            />
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {funds && funds?.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "26%" }}>Fondos de reserva</th>
                      <th className="border-0" style={{ width: "22%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Fecha del gasto</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Cuota</th>
                    </tr>
                  </thead>
                  <tbody>
                    {funds &&
                      funds.map((pay, index) => (
                        <tr key={index}>
                          <td className="align-middle">
                            <h6 className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.name
                                : pay?.property?.reserve_fund.name}
                            </h6>
                          </td>
                          <td className="align-middle">
                            <p className="mb-0">
                              {pay?.property?.finance != null
                                ? pay?.property?.finance?.description
                                : pay?.property?.reserve_fund?.description}
                            </p>
                          </td>
                          {lineDateAndRateCells(pay?.property)}
                          {lineTotalCell(pay?.property)}
                          <td className="align-middle text-right">
                            <span className="d-block font-weight-semi-bold">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={`${baseCurrency.symbol} `}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={pay?.property?.amount}
                              />
                            </span>
                            {activeRate?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  prefix={activeRate.currency.iso + " "}
                                  allowedDecimalSeparators={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  thousandSeparator={true}
                                  value={
                                    pay?.property?.amount * (activeRate?.value || 0)
                                  }
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      ))}

                    <tr className="border-top">
                      <th className="text-900" colSpan={5}>
                        Total de fondos de reserva
                      </th>
                      <td className="font-weight-semi-bold text-right">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`${baseCurrency.symbol} `}
                            value={amountF}
                          />
                        </span>
                        {activeRate?.currency?.iso && (
                          <span className="d-block text-700 fs--2 text-nowrap">
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              prefix={activeRate.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={amountF * (activeRate?.value || 0)}
                            />
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {reportIncomes && reportIncomes.length > 0 && (
              <div className="table-responsive mt-4 fs--1">
                <Table striped className="border-bottom">
                  <thead>
                    <tr>
                      <th className="border-0" style={{ width: "26%" }}>Ingresos aplicados</th>
                      <th className="border-0" style={{ width: "22%" }}>Descripción</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Fecha del ingreso</th>
                      <th className="border-0" style={{ width: "12%", whiteSpace: "nowrap" }}>Tasa</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Monto</th>
                      <th className="border-0 text-right" style={{ width: "14%" }}>Descuento</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reportIncomes.map((pay, index) => (
                      <tr key={index}>
                        <td className="align-middle">
                          <h6 className="mb-0">
                            {pay?.property?.name || pay?.property?.income?.name || "Ingreso a planilla"}
                          </h6>
                        </td>
                        <td className="align-middle">
                          <p className="mb-0">
                            {pay?.property?.description || pay?.property?.income?.description}
                          </p>
                        </td>
                        {lineDateAndRateCells(pay?.property)}
                        {lineTotalCell(pay?.property)}
                        <td className="align-middle text-right">
                          <span className="d-block font-weight-semi-bold text-success">
                            <NumberFormat
                              className="text-nowrap"
                              displayType="text"
                              prefix={`- ${baseCurrency.symbol} `}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={Math.abs(pay?.property?.amount || 0)}
                            />
                          </span>
                          {activeRate?.currency?.iso && (
                            <span className="d-block text-700 fs--2 text-nowrap text-success">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                prefix={"- " + activeRate.currency.iso + " "}
                                allowedDecimalSeparators={true}
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator={true}
                                value={Math.abs(pay?.property?.amount || 0) * (activeRate?.value || 0)}
                              />
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}

                    {/* Cuando la planilla cubre solo una parte del período, el
                        crédito se repartió entre todas las categorías por peso.
                        El backend manda la porción que le tocó a esta planilla;
                        sin ella el total de arriba se lee como si se hubiera
                        descontado entero acá. */}
                    {incomeCreditShare !== null &&
                      Math.abs(incomeCreditShare - amountIncomes) > 0.01 && (
                        <tr className="border-top">
                          <th className="text-900 font-weight-semi-bold" colSpan={5}>
                            Aplicado a esta planilla{" "}
                            <span className="text-600 font-weight-normal fs--2">
                              (parte prorrateada)
                            </span>
                          </th>
                          <td className="font-weight-semi-bold text-right text-success">
                            <span className="d-block">
                              <NumberFormat
                                className="text-right text-nowrap"
                                displayType="text"
                                allowedDecimalSeparators={true}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale
                                prefix={`- ${baseCurrency.symbol} `}
                                value={incomeCreditShare}
                              />
                            </span>
                            {activeRate?.currency?.iso && (
                              <span className="d-block text-700 fs--2 text-nowrap text-success">
                                <NumberFormat
                                  className="text-right text-nowrap"
                                  displayType="text"
                                  prefix={"- " + activeRate.currency.iso + " "}
                                  allowedDecimalSeparators={true}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  value={incomeCreditShare * (activeRate?.value || 0)}
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      )}

                    <tr className="border-top">
                      <th className="text-900" colSpan={5}>
                        Total ingresos del período
                      </th>
                      <td className="font-weight-semi-bold text-right text-success">
                        <span className="d-block">
                          <NumberFormat
                            className="text-right text-nowrap"
                            displayType="text"
                            allowedDecimalSeparators={true}
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale
                            prefix={`- ${baseCurrency.symbol} `}
                            value={amountIncomes}
                          />
                        </span>
                        {activeRate?.currency?.iso && (
                          <span className="d-block text-700 fs--2 text-nowrap text-success">
                            <NumberFormat
                              className="text-right text-nowrap"
                              displayType="text"
                              prefix={"- " + activeRate.currency.iso + " "}
                              allowedDecimalSeparators={true}
                              decimalScale={2}
                              fixedDecimalScale
                              thousandSeparator={true}
                              value={amountIncomes * (activeRate?.value || 0)}
                            />
                          </span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            <Row noGutters className="justify-content-end">
              {datas?.voucher && datas?.voucher !== "false" && (
                <Col sm={12}>
                  <Table
                    striped
                    size="sm"
                    borderless
                    className="fs--1 text-left"
                  >
                    <thead>
                      <tr>
                        <th className="border-0">Comprobante de pago</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="App mt-3">
                            <img
                              src={datas?.voucher}
                              style={{
                                height: "400px",
                                width: "400px",
                                maxHeight: "400px",
                                maxWidth: "400px",
                                backgroundRepeat: "no-repeat",
                              }}
                              alt="Factura"
                            />
                          </div>
                          {/*        <div className="d-flex align-items-center justify-content-start">
                            <div
                              style={{
                                backgroundImage: `url('${
                                  import.meta.env.VITE_URL
                                }/view/image/${token}?path=${
                                  user?.voucher
                                }&size=large')`,
                                backgroundSize: "contain",
                                height: "400px",
                                width: "400px",
                                maxHeight: "400px",
                                maxWidth: "400px",
                                backgroundRepeat: "no-repeat",
                              }}
                            />
                          </div> */}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  {loadingConfig ? (
                    <Spinner />
                  ) : (
                    <div className="text-start text-muted mt-3 pt-1 mb-0">
                      <Logo
                        to={null}
                        styleImage={{
                          width: "100px",
                        }}
                        className={"mb-2"}
                      />
                      <div className="mb-0">
                        {dataConfig?.data?.note !== "" && (
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            className="mr-2"
                            size="sm"
                          />
                        )}
                        <pre
                          style={{
                            fontFamily: "Open Sans",
                            fontSize: ".83333rem",
                            color: "#5e6e82",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                          }}
                        >
                          {dataConfig?.data.note}
                        </pre>
                      </div>
                    </div>
                  )}
                </Col>
              )}
            </Row>
            <Modal isOpen={collapseOne} data-testid="modal">
              <ModalHeader>Confirmación</ModalHeader>
              <ModalBody>
                <p className="mb-0 font-weight-bold fs--1">
                  ¿Está seguro de cancelar el pago? Podrá realizar nuevamente el
                  pago.
                </p>
              </ModalBody>
              <ModalFooter>
                <Button onClick={() => collapseOneOpen(!collapseOne)}>
                  Cancelar
                </Button>
                <Button
                  data-testid="submit-button"
                  color="primary"
                  type="submit"
                  onClick={cancel}
                >
                  Sí, cancelar
                </Button>
              </ModalFooter>
            </Modal>
          </CardBody>
        </Card>
      </Fragment>
    </Fragment>
  );
};

export default withRedirect(PropertyPaymentDetail);
